import React from "react";
import { Provider } from "react-redux";
import GlobalStyles from "@iso/assets/styles/globalStyle";
import { store } from "./redux/store";
import Boot from "./redux/boot";
import Routes from "./router";
import AppProvider from "./AppProvider";
import { StolleAPIGet, getLoginToken } from "./library/helpers/utilityStolle";

window.addEventListener("click", () => {
  if (!getLoginToken()) return;
  const encryptedLastActiveTime = sessionStorage.getItem("lastActiveTime");
  if (!!encryptedLastActiveTime) {
    const expiresTime = 15; //in minutes
    const lastActiveTime = JSON.parse(encryptedLastActiveTime);
    const compared = {
      stored: lastActiveTime,
      now: Date.now(),
      diff: Date.now() - lastActiveTime,
      isOver15min: Date.now() - lastActiveTime > expiresTime * 60 * 1000,
    };

    if (compared.isOver15min) {
      StolleAPIGet(
        "/getAnnouncement",
        {
          headers: {
            token: getLoginToken(),
          },
        },
        false,
        process.env.REACT_APP_API_DOMAIN_V2
      );
    }
  }
  sessionStorage.setItem("lastActiveTime", JSON.stringify(Date.now()));
});

const App = () => {
  return (
    <>
      <Provider store={store}>
        <AppProvider>
          <>
            <GlobalStyles />
            <Routes />
          </>
        </AppProvider>
      </Provider>
    </>
  );
};
Boot()
  .then(() => App())
  .catch((error) => console.error(error));

export default App;
